/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Cli_OverlineInputs */

const en_hub_cli_overline = /** @type {(inputs: Hub_Cli_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command line`)
};

const id_hub_cli_overline = /** @type {(inputs: Hub_Cli_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baris perintah`)
};

/**
* | output |
* | --- |
* | "Command line" |
*
* @param {Hub_Cli_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_cli_overline = /** @type {((inputs?: Hub_Cli_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Cli_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_cli_overline(inputs)
	return en_hub_cli_overline(inputs)
});